import { createApp } from "vue";
import BaseAlert from "@/components/Common/BaseAlert.vue";

export default {
  install(app) {
    app.config.globalProperties.$alert = ({ title, message, onConfirm }) => {
      const container = document.createElement("div");
      document.getElementById("app")?.appendChild(container); // 또는 document.body

      const alertApp = createApp(BaseAlert, {
        title,
        message,
        onConfirmCallback: onConfirm,
      });

      alertApp.mount(container);
    };
  },
};
